import { render, staticRenderFns } from "./BeginOrderForm.vue?vue&type=template&id=40ccc9e0"
import script from "./BeginOrderForm.vue?vue&type=script&lang=js"
export * from "./BeginOrderForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports